import { SimplifiedIAPIClient, uploadFiles } from '@askporter/utils';
export type { SimplifiedIAPIClient };
export default uploadFiles;
